/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {Route, UrlMatchResult} from './config';
import {UrlSegment, UrlSegmentGroup} from './url_tree';


/**
 * @whatItDoes Name of the primary outlet.
 *
 * @stable
 */
export const /** @type {?} */ PRIMARY_OUTLET = 'primary';

/**
 * A collection of parameters.
 *
 * @stable
 */
export type Params = {
  [key: string]: any
};
export class NavigationCancelingError extends Error {
public stack: any;
/**
 * @param {?} message
 */
constructor(public message: string) {
    super(message);
    this.stack = (<any>new Error(message)).stack;
  }
/**
 * @return {?}
 */
toString(): string { return this.message; }
}

function NavigationCancelingError_tsickle_Closure_declarations() {
/** @type {?} */
NavigationCancelingError.prototype.stack;
/** @type {?} */
NavigationCancelingError.prototype.message;
}

/**
 * @param {?} segments
 * @param {?} segmentGroup
 * @param {?} route
 * @return {?}
 */
export function defaultUrlMatcher(
    segments: UrlSegment[], segmentGroup: UrlSegmentGroup, route: Route): UrlMatchResult {
  const /** @type {?} */ path = route.path;
  const /** @type {?} */ parts = path.split('/');
  const /** @type {?} */ posParams: {[key: string]: UrlSegment} = {};
  const /** @type {?} */ consumed: UrlSegment[] = [];

  let /** @type {?} */ currentIndex = 0;

  for (let /** @type {?} */ i = 0; i < parts.length; ++i) {
    if (currentIndex >= segments.length) return null;
    const /** @type {?} */ current = segments[currentIndex];

    const /** @type {?} */ p = parts[i];
    const /** @type {?} */ isPosParam = p.startsWith(':');

    if (!isPosParam && p !== current.path) return null;
    if (isPosParam) {
      posParams[p.substring(1)] = current;
    }
    consumed.push(current);
    currentIndex++;
  }

  if (route.pathMatch === 'full' &&
      (segmentGroup.hasChildren() || currentIndex < segments.length)) {
    return null;
  } else {
    return {consumed, posParams};
  }
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
